import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconFileVisualizationOutline } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import messages from '../../../OutstandingView/dashboardActions/TopUpPending/TopUpPending.messages';
import styles from '../TopUpStatusAlertBox.module.css';

export const TopUpPendingAlert = ({
    requestedAmount,
    requestedCashAmount
}: {
    requestedAmount: number;
    requestedCashAmount: number | undefined;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            icon={
                <IconFileVisualizationOutline
                    className={styles.blueAlertBoxIcon}
                />
            }
            className={styles.blueAlertBox}
            description={
                <>
                    <strong>
                        <FormattedMessage {...messages.title} /> -{' '}
                    </strong>

                    {requestedCashAmount ? (
                        <FormattedMessage
                            {...messages.description}
                            values={{
                                amount: (
                                    <strong>
                                        <FormattedCurrency
                                            value={requestedCashAmount}
                                        />
                                    </strong>
                                )
                            }}
                        />
                    ) : (
                        <FormattedMessage
                            {...messages.fallbackDescription}
                            values={{
                                amount: (
                                    <strong>
                                        <FormattedCurrency
                                            value={requestedAmount}
                                        />
                                    </strong>
                                )
                            }}
                        />
                    )}
                </>
            }
        />
    );
};
